import { Injectable, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private cookie = inject(CookieService);

  private domainPath = '/';
  private expiresDays = 365;

  public getAsObject(data: string): any {
    try {
      return data ? JSON.parse(data) : null;
    } catch (e) {
      return data;
    }
  }

  public get(name: string): any {
    const data = this.cookie.get(name);
    return this.getAsObject(data);
  }

  public set(name: string, value: string, expires = this.expiresDays): void {
    this.cookie.set(name, value, expires, this.domainPath);
  }

  public has(name: string): boolean {
    return this.cookie.check(name);
  }

  public remove(name: string): void {
    this.cookie.delete(name, this.domainPath);
  }

  public clearStorage(): void {
    this.cookie.deleteAll(this.domainPath);
  }

  public useOnce(name: string): any {
    let result = '';
    if (this.has(name)) {
      result = this.get(name);
      this.remove(name);
    }
    return result;
  }
}
